import { AUTH_ROUTES } from "./authRoutes";
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FullScreenLoader from './FullScreenLoader';
import { useFcmToken } from '../firebase/useFcmToken';

function ProtectedRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, isInitialized } = useAuth();

  // Register FCM push token once the user is authenticated
  useFcmToken();

  if (!isInitialized) {
    return <FullScreenLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={AUTH_ROUTES.signIn} replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  return children;
}

export default ProtectedRoute;
